import { Injectable } from '@angular/core';
import { ApiService } from './api.base.service';
import { IWService } from '../iw.service';
import { ApiDocumentProcessGridModel } from '../../models/api-document-process-grid.model';
import { SignatureResponse, SignatureResponseWithoutWallet } from '../../models/signature-response';
import { GetContent, GetContentWithoutWallet } from '../../models/get-content';
import { SDKOperationRequest } from '@extrimian/identity-wallet';
import { SignContent } from '../../models/sign-content';
import { ApiDocumentProcessModel } from '../../models/api-document-process.model';
import { VerifyResponse } from '../../models/verify-response.model';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({ providedIn: "root" })
export class GuardianProxyService {
    baseUrl = "api/guardianproxy-signature";

    constructor(
        private apiService: ApiService,
        private iwService: IWService,
        public http: HttpClient
    ) { }

    async extrSignProcessAddAssertion(userByOrganizationId: number, language: string) {
        var fromAddress: string;
        fromAddress = await (await this.iwService.getIW()).getMainAddress();
        var response: SignatureResponseWithoutWallet;        
                let getContent: GetContentWithoutWallet = {
                    RootObjectId: userByOrganizationId,
                    language: language,
                    fromAddress: fromAddress,                    
                };
                response = await this.apiService.post<SignatureResponseWithoutWallet>(
                    `${this.baseUrl}/getaddassertioncontent`,
                    getContent
                );           
        if (response != null) {
            let signContent: SignContent = {
                fromAddress: fromAddress,
                signatureId: response.signatureId,
                signature: '',
            };
            return await this.apiService.post(
                `${this.baseUrl}/addassertionsigncontent`,
                signContent
            );
        } else {
            return;
        }
    }

    async rollBackAddAssertionSignContent(userByOrganizationId: number) {
        return await this.apiService.post(
            `${this.baseUrl}/rollbackaddassertionsigncontent/${userByOrganizationId}`
        );
    }

    
    
}
